import { CrossSellingPointer } from "../../others";
import { RPM } from ".";
import $ from "jquery";

const crossRpmMove = () => {
  var _rml;

  return CrossSellingPointer.isActionAvailable(RPM, "move") && ((_rml = window.rml) === null || _rml === void 0 ? void 0 : _rml.hooks.register("attachment/move/finished", (ids, to) => {
    new CrossSellingPointer($(".rml-container:visible li[data-li-id=\"".concat(to, "\"]")), RPM, "move");
  }));
};

export { crossRpmMove };